import { render, staticRenderFns } from "./VariationEdit.vue?vue&type=template&id=63d6a9f7"
import script from "./VariationEdit.vue?vue&type=script&lang=js"
export * from "./VariationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports